import AttachmentResultCode from 'owa-service/lib/contract/AttachmentResultCode';

export default {
    AttachmentComposeSPLinks: { datapoint: { name: 'AttachmentComposeSPLinks' } },
    AttachmentComposeSPLinksShouldReplaceText: {
        datapoint: { name: 'AttachmentComposeSPLinksShouldReplaceText' },
    },
    AttachmentComposeSPLinksResponseHasInvalidFileName: {
        datapoint: { name: 'AttachmentComposeSPLinksResponseHasValidFileName' },
    },
    ComposeSPLinksFromPaste: {
        datapoint: {
            name: 'ComposeSPLinksFromPaste',
            customData: (linkType: string) => [linkType],
        },
    },
    ComposeSPLinksFromDraft: {
        datapoint: {
            name: 'ComposeSPLinksFromDraft',
            customData: (linkType: string) => [linkType],
        },
    },
    UnderTenSPLinksWhenProcessAnchorElements: {
        datapoint: {
            name: 'UnderTenSPLinksWhenProcessAnchorElements',
            customData: (fromPaste: boolean, totalLinkCount: number) => [fromPaste, totalLinkCount],
        },
    },
    AtLeastTenSPLinksWhenProcessAnchorElements: {
        datapoint: {
            name: 'AtLeastTenSPLinksWhenProcessAnchorElements',
            customData: (fromPaste: boolean) => [fromPaste],
        },
    },
    ComposeEditorIsNullDuringProcessSPLinks: {
        datapoint: {
            name: 'ComposeEditorIsNullDuringProcessSPLinks',
            customData: (linkCount: number) => [linkCount],
        },
    },
    GetSharingInformationFailure: {
        datapoint: {
            name: 'GetSharingInformationFailure',
            customData: (error: string, resultCode: AttachmentResultCode) => [error, resultCode],
        },
    },
};
